import { render, staticRenderFns } from "./loginFooter.vue?vue&type=template&id=f1f4b9e0&scoped=true"
import script from "./loginFooter.vue?vue&type=script&lang=js"
export * from "./loginFooter.vue?vue&type=script&lang=js"
import style0 from "./loginFooter.vue?vue&type=style&index=0&id=f1f4b9e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f4b9e0",
  null
  
)

export default component.exports